import { FONT, RADIUS } from "@/styles/common";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CustomFlex = styled(Flex)`
    border: 1px solid ${({ theme }) => theme.COLOR.text[300]};
`;

export const CustomText = styled(Text)`
    padding: 8px 0;
    text-align: center;
    color: ${({ theme }) => theme.COLOR.text[500]};
    background: ${({ theme }) => theme.COLOR.pagination[100]};
    box-sizing: border-box;
    border-bottom: 1px solid ${({ theme }) => theme.COLOR.text[300]};
    ${RADIUS(2)}
    ${FONT("pretendard", 16, 500)}
`;
